// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 14px;
  color: #333;
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

mat-sidenav-container {
  overflow-x: hidden;
}

.container {
  padding-bottom: 10vh;
  height: calc(100% - 64px);
  overflow-y: auto;
  overflow-x: hidden;
}

mat-sidenav-content {
  transition: margin-left 0.3s ease-in-out;
  overflow-x: hidden;
}

.content {
  margin: 2em;
  transition: margin-left 0.3s ease-in-out;
}

footer {
  height: 10vh;
  min-width: 100vw;
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  bottom: 0;
  background-color: white;
  border-top: 1px solid #bbb;
  text-align: center;
  left: 0;
  width: 100%;
  z-index: 5;
}

#copyright {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
#copyright p:last-child {
  margin: 0;
}

.toolbar-spacer {
  flex: 1 1 auto;
}

.active {
  background-color: #946DDA;
}

small {
  font-size: 13px;
}

mat-toolbar {
  position: sticky;
  top: 0;
  z-index: 10;
  transition: top 0.3s ease-out;
}
mat-toolbar.with-banner {
  top: 48px;
}

.connection-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: #d32f2f;
  color: white;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  z-index: 1001;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  font-weight: 500;
  animation: slideDown 0.3s ease-out;
}
.connection-banner mat-icon {
  font-size: 24px;
  height: 24px;
  width: 24px;
}

@keyframes slideDown {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}
.app-sidenav {
  width: 260px;
  border-right: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  background-color: #fafafa;
  height: calc(100vh - 64px - 10vh) !important;
  max-height: calc(100vh - 64px - 10vh) !important;
  transition: width 0.3s ease-in-out;
  overflow-x: hidden !important;
}
.app-sidenav.collapsed {
  width: 64px;
}
.app-sidenav.collapsed .sidenav-nav .mat-list-item {
  justify-content: center;
}
.app-sidenav.collapsed .sidenav-nav .mat-list-item .mat-list-item-content {
  justify-content: center;
  padding: 0 !important;
}
.app-sidenav.collapsed .sidenav-nav .mat-list-item mat-icon {
  margin-right: 0;
}
.app-sidenav.collapsed .sidenav-nav .mat-list-item span[matListItemTitle] {
  display: none;
}

.sidenav-header {
  padding: 16px;
  background: linear-gradient(135deg, #673ab7 0%, #512da8 100%);
  color: white;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.sidenav-header .user-info-header {
  display: flex;
  align-items: center;
  gap: 12px;
}
.sidenav-header .user-info-header mat-icon {
  font-size: 36px;
  width: 36px;
  height: 36px;
  color: white;
}
.sidenav-header .user-info-header .user-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}
.sidenav-header .user-info-header .user-details .user-email {
  font-size: 14px;
  font-weight: 500;
  color: white;
  word-break: break-all;
}
.sidenav-header .user-info-header .user-details .version-text {
  font-size: 11px;
  opacity: 0.85;
  color: white;
}
.sidenav-header .logout-button-header {
  width: 100%;
  color: white;
  border-color: rgba(255, 255, 255, 0.5);
}
.sidenav-header .logout-button-header:hover {
  background-color: rgba(255, 255, 255, 0.1);
  border-color: white;
}
.sidenav-header .logout-button-header mat-icon {
  margin-right: 8px;
}
.sidenav-header .user-info-header-collapsed {
  display: flex;
  justify-content: center;
  align-items: center;
}
.sidenav-header .user-info-header-collapsed mat-icon {
  color: white;
  font-size: 32px;
  width: 32px;
  height: 32px;
}
.sidenav-header .logout-button-collapsed {
  color: white;
}
.sidenav-header .logout-button-collapsed mat-icon {
  color: white;
}

.sidenav-nav {
  flex: 1;
  padding: 8px 0;
  padding-bottom: 8px;
  overflow-y: auto;
  overflow-x: hidden;
  --mdc-list-list-item-label-text-size: 12px;
}
.sidenav-nav a[mat-list-item] {
  color: #333;
  transition: all 0.2s ease;
  margin: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  height: 44px;
}
.sidenav-nav a[mat-list-item]:hover {
  background-color: #eeeeee;
}
.sidenav-nav a[mat-list-item].active {
  background-color: #ede7f6;
  color: #673ab7;
  font-weight: 500;
  border-left: 3px solid #673ab7;
}
.sidenav-nav a[mat-list-item].active mat-icon {
  color: #673ab7;
}
.sidenav-nav a[mat-list-item] mat-icon {
  margin-right: 12px;
  color: #666;
}
.sidenav-nav mat-divider {
  margin: 8px 0;
}

.nav-expansion-panel {
  box-shadow: none !important;
  background-color: transparent !important;
  margin: 4px 0 !important;
}
.nav-expansion-panel::before {
  display: none;
}
.nav-expansion-panel .mat-expansion-panel-header {
  padding: 0 16px;
  height: 44px;
  border-radius: 4px;
  transition: all 0.2s ease;
  font-size: 12px;
}
.nav-expansion-panel .mat-expansion-panel-header:hover {
  background-color: #eeeeee;
}
.nav-expansion-panel .mat-expansion-panel-header .expansion-title {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #333;
  font-weight: 500;
  font-size: 12px;
}
.nav-expansion-panel .mat-expansion-panel-header .expansion-title mat-icon {
  color: #666;
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.nav-expansion-panel .mat-expansion-panel-body {
  padding: 0 !important;
}
.nav-expansion-panel .mat-expansion-panel-body a[mat-list-item] {
  padding-left: 48px;
  font-size: 12px;
  height: 38px;
}
.nav-expansion-panel .mat-expansion-panel-body a[mat-list-item] mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

/* Responsive Styles */
@media screen and (max-width: 768px) {
  .app-sidenav {
    width: 280px;
  }
  mat-sidenav-container .mat-drawer-side {
    border-right: none;
  }
}
@media screen and (max-width: 767px) {
  .card-container > *:not(.circle-link),
  .terminal {
    width: 100%;
  }
  .card {
    height: 16px;
    margin: 8px 0;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
